import { fetchData } from "./fetchData";

//speed notifications
export const getSpeedNotificationsAPI = async(RunID) => {
    const route = `/runs/${RunID}/speed-notifications`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

export const createSpeedNotificationAPI = async(RunID, notificationData) => {
    const route = `/runs/${RunID}/speed-notifications`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(notificationData)
    }

    let response = await fetchData(route, options);

    return response;
}

export const updateSpeedNotificationAPI = async(NotificationID, notificationData) => {
    const route = `/runs/speed-notifications/${NotificationID}`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(notificationData)
    }

    let response = await fetchData(route, options);

    return response;
}

export const deleteSpeedNotificationAPI = async(NotificationID) => {
    const route = `/runs/speed-notifications/${NotificationID}`;

    const options = {
        method: 'DELETE',
    }

    let response = await fetchData(route, options);

    return response;
}

/**
 * @description Get notifications with POI data by JobID
 * @param {Number} JobID
 */
export const getNotificationWithPOIByJob = async(jobID, userID) => {
    const route = `/notifications/job/${jobID}?user=${userID}`;

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}

/**
 * @description Create notifications for POI
 * @param {Object} data
 */
export const createPOINotificationAPI = async(data) => {
    const route = `/notifications/poi`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }

    const response = await fetchData(route, options);

    return response;
}

/**
 * @description Delete notifications for POI
 * @param {Object} data
 */
export const deletePOINotificationAPI = async(data) => {
    const route = `/notifications/poi`;

    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }

    const response = await fetchData(route, options);

    return response;
}